import Person from './person.js';

export default class Beneficiary extends Person
{
    constructor(code, id, firstName, secondName, thirdName, forthName, lastName, dateOfBirth, motherName, maritalStatus, bloodType, nationalitie, religion, doctrine, gender, note
        , relationship = null, familyId = null
    ){ 
        super(code, id, firstName, secondName, thirdName, forthName, lastName, dateOfBirth, motherName, maritalStatus, bloodType, nationalitie, religion, doctrine, gender, note)

        this.relationship   = relationship
        this.familyId       = familyId
        
        // Related Data to Beneficiary
        this.skills                 = []
        this.contacts               = []
        this.educations             = []
        this.selfEmployment         = null
        this.socialMedia            = null
        this.newIdentificationCard  = null
        this.oldIdentificationCard  = null
        this.passport               = null
        this.rationCard             = null
        this.residentialCard        = null
        this.jobRecord              = null
        this.sacrificer             = null
        this.init()
    }

    setSkills(skills){
        this.skills = skills
        return this
    }

    setContacts(contacts){
        this.contacts = contacts
        return this
    }

    setEducations(educations){
        this.educations = educations
        return this
    }

    setSelfEmployment(selfEmployment){
        this.selfEmployment = selfEmployment
        return this
    }

    setSocialMedia(socialMedia){
        this.socialMedia = socialMedia
        return this
    }

    setNewIdentificationCard(newIdentificationCard){
        this.newIdentificationCard = newIdentificationCard
        return this
    }

    setOldIdentificationCard(oldIdentificationCard){
        this.oldIdentificationCard = oldIdentificationCard
        return this
    }

    setPassport(passport){
        this.passport = passport
        return this
    }

    setRationCard(rationCard){
        this.rationCard = rationCard
        return this
    }

    setResidentialCard(residentialCard){
        this.residentialCard = residentialCard
        return this
    }

    setJobRecord(jobRecord){
        this.jobRecord = jobRecord
        return this
    }
    
    setSacrificer(sacrificer){
        this.sacrificer = sacrificer
        return this
    }
    
    mapToCreate(){
        return {
            firstName:          this.firstName              ?? null,
            secondName:         this.secondName             ?? null,
            thirdName:          this.thirdName              ?? null,
            forthName:          this.forthName              ?? null,
            lastName:           this.lastName               ?? null,
            dateOfBirth:        this.dateOfBirth            ?? null,
            motherName:         this.motherName             ?? null,
            gender:             this.gender?.value          ?? null,
            maritalStatus:      this.maritalStatus?.value   ?? null,
            bloodType:          this.bloodType?.value       ?? null,
            nationalityEnum:    this.nationalitie?.value    ?? null,
            religionEnum:       this.religion?.value        ?? null,
            doctrineEnum:       this.religion?.value == 1 ? (this.doctrine?.value ?? null) : null,
            notes:              this.note                   ?? null,
        }
    }
}
